import { X } from "lucide-react"

import { Badge } from "@/components/ui/badge"
import { getProgramLabel } from "@/config/schools"
import { getDifficultyLabel } from "@/lib/academy/difficulty"

interface ActiveFiltersBarProps {
  search: string
  category: string
  difficulty: string
  totalResults: number
  onRemoveSearch: () => void
  onRemoveCategory: () => void
  onRemoveDifficulty: () => void
  onClearAll: () => void
}

export function ActiveFiltersBar({
  search,
  category,
  difficulty,
  totalResults,
  onRemoveSearch,
  onRemoveCategory,
  onRemoveDifficulty,
  onClearAll,
}: ActiveFiltersBarProps) {
  const hasFilters = Boolean(search || category || difficulty)

  return (
    <div className="motion-fade mb-6 flex flex-wrap items-center gap-2">
      <span className="text-xs font-bold text-muted-foreground">
        {totalResults} {totalResults === 1 ? "curso encontrado" : "cursos encontrados"}
      </span>

      {hasFilters && <div className="mx-1 h-4 w-px bg-foreground/10" />}

      {search && (
        <Badge variant="outline" className="motion-pop flex items-center gap-1.5 py-1">
          "{search}"
          <button onClick={onRemoveSearch} aria-label="Quitar búsqueda" className="transition-colors duration-150 hover:text-primary">
            <X className="h-3 w-3" />
          </button>
        </Badge>
      )}

      {category && (
        <Badge variant="outline" className="motion-pop flex items-center gap-1.5 py-1">
          {getProgramLabel(category)}
          <button onClick={onRemoveCategory} aria-label="Quitar filtro de programa" className="hover:text-primary">
            <X className="h-3 w-3" />
          </button>
        </Badge>
      )}

      {difficulty && (
        <Badge variant="outline" className="motion-pop flex items-center gap-1.5 py-1">
          {getDifficultyLabel(difficulty)}
          <button onClick={onRemoveDifficulty} aria-label="Quitar filtro de dificultad" className="hover:text-primary">
            <X className="h-3 w-3" />
          </button>
        </Badge>
      )}

      {hasFilters && (
        <button
          onClick={onClearAll}
          className="text-micro font-bold text-muted-foreground underline-offset-2 hover:text-foreground hover:underline"
        >
          Limpiar todo
        </button>
      )}
    </div>
  )
}
